import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useCoachFeedback(programId) {
  const [coachFeedback, setCoachFeedback] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.programs.coachFeedback(programId))
      .then((response) => {
        setCoachFeedback(response.data.data);
      });
  }, []);

  return coachFeedback;
}
